import React, {useEffect} from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import IntlMessages from "util/IntlMessages";
import {useForm} from "react-hook-form";
import CircularProgress from '@material-ui/core/CircularProgress';


const FormDialog = ({open, handleClose, title, form, maxWidth='sm', saving=false, initState={}, errors={}, extraProps={}, initData={}}) => {

    const {register, handleSubmit, setValue, control} = useForm();
    const onSubmit = data => {
        handleClose(true, data)
    };

    useEffect(() => {
        Object.keys(initData).map(key => {
            register({name: key});
            setValue(key, initData[key]);
        })
    }, [initData])

    return (
        <Dialog
            scroll='body'
            fullWidth
            maxWidth={maxWidth}
            open={open}
            // onClose={handleClose(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >

            <form onSubmit={handleSubmit(onSubmit)} autocomplete="off">
                <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
                <DialogContent>
                    {form({register, setValue, control, open, initState,errors , extraProps, initData})}
                </DialogContent>
                <DialogActions>
                    <div className='position-relative'>
                        <Button type={'submit'} color="primary" disabled={saving}>
                            <IntlMessages id='save'/>
                        </Button>
                        {saving && <CircularProgress size={24} className='position-absolute text-primary'/>}
                    </div>
                    <Button onClick={() => handleClose(false, [])} color="warning" autoFocus disabled={saving}>
                        <IntlMessages id='cancel'/>
                    </Button>
                </DialogActions>
            </form>
        </Dialog>
    );
}

export default FormDialog
